import { Validator } from 'vee-validate';
import { convertToFloatFormat } from '../helper';

// Create a singleton instance to store component reference
const ValidationContext = {
  component: null,
  setComponent(comp) {
    this.component = comp;
  },
};

// Modified validators to use the ValidationContext
const grossValidator = () => {
  const component = ValidationContext.component;
  if (!component?.inputFields) return { valid: true };

  // Use the convertToFloatFormat to properly handle comma as decimal separator
  let vat = convertToFloatFormat(component.inputFields.vat.model);
  const net = convertToFloatFormat(component.inputFields.net.model);
  const gross = convertToFloatFormat(component.inputFields.gross.model);

  // If vat is 0 but we have additionalVats, calculate vat from them
  if (parseFloat(vat) === 0 && component.additionalVats && component.additionalVats.length > 0) {
    vat = component.additionalVats
      .reduce(
        (accumulator, currentVat) =>
          accumulator + parseFloat(convertToFloatFormat(currentVat.vat.value[0])),
        0
      )
      .toFixed(2);
  }

  const sum = (parseFloat(vat) + parseFloat(net)).toFixed(2);
  const grossFormatted = parseFloat(gross).toFixed(2);

  const valid = sum === grossFormatted;

  return {
    valid,
    data: {
      message: valid ? '' : 'Seštevek neto zneska in davka se ne ujema z bruto zneskom',
    },
  };
};

const netValidator = () => {
  const component = ValidationContext.component;
  if (!component?.inputFields || !component?.additionalVats) return { valid: true };

  const net = component.inputFields.net.model;
  const netSum = component.additionalVats
    .reduce(
      (accumulator, currentVat) =>
        accumulator + parseFloat(convertToFloatFormat(currentVat.net.value[0])),
      0
    )
    .toFixed(2);
  const valid = netSum === net;

  return {
    valid,
    data: {
      message: valid ? '' : 'Seštevek neto zneska stopenj in neto zneska se ne ujema!',
    },
  };
};

const vatValidator = (value) => {
  const component = ValidationContext.component;
  if (!component?.additionalVats) return { valid: true };

  const vatSum = component.additionalVats
    .reduce(
      (accumulator, currentVat) =>
        accumulator + parseFloat(convertToFloatFormat(currentVat.vat.value[0])),
      0
    )
    .toFixed(2);
  const valid = vatSum === convertToFloatFormat(value);

  return {
    valid,
    data: {
      message: valid ? '' : 'Seštevek davčnih stopenj in davka se ne ujema!',
    },
  };
};

const vatNumberValidator = (value) => {
  const valid = /( ?[A-Z]){0,3}( ?[0-9A-Z]){6,15}/.test(value);
  return {
    valid,
    data: {
      message: valid ? '' : 'ni pravilne oblike',
    },
  };
};

const clientAndPartnerValidator = (_, [val1, val2]) => {
  let valid = true;
  if (val1 && val2) {
    const vat1 = typeof val1 === 'string' ? val1 : val1.Davcna;
    const vat2 = typeof val2 === 'string' ? val2 : val2.Davcna;
    valid = !(vat1.endsWith(vat2) || vat2.endsWith(vat1));
  }
  return {
    valid,
    data: {
      message: valid ? '' : 'Prejemnik in izdajatelj računa mora biti različna!',
    },
  };
};

const dateWarningValidator = () => {
  // Always return valid, since this is just a warning
  return {
    valid: true,
    data: {
      // Just indicate this field should show date warnings
      show_date_warning: true,
    },
  };
};

// Register validators immediately
Validator.extend('vat_id', {
  validate: vatNumberValidator,
  getMessage: (field, params, data) => `${field} ${data.message}`,
});

Validator.extend('vat', {
  validate: vatValidator,
  getMessage: (field, params, data) => data.message,
});

Validator.extend('net', {
  validate: netValidator,
  getMessage: (field, params, data) => data.message,
});

Validator.extend('client_and_partner', {
  validate: clientAndPartnerValidator,
  getMessage: (field, params, data) => data.message,
});

Validator.extend('gross', {
  validate: grossValidator,
  getMessage: (field, params, data) => data.message,
});

Validator.extend('date_warning', {
  validate: dateWarningValidator,
  // Empty message since we're handling the warning in the component
  getMessage: () => '',
});
export default {
  created() {
    ValidationContext.setComponent(this);
  },
  beforeDestroy() {
    // Clear the reference when component is destroyed
    if (ValidationContext.component === this) {
      ValidationContext.setComponent(null);
    }
  },
};
